import React, { useState } from 'react'
import Single from '../../../componentes/Single'
import {Modal, Icon, Dropdown, Input, Table} from 'semantic-ui-react'
import { getCompanyCollection } from '../../../firebase'
import DateUtilities from '../../../componentes/DateUtilities'
import AlmDropdown from '../../../componentes/AlmDropdown'
import Aplicar from './aplicar'

const Aplicaciones = (props) => {
    const [open, setOpen] = useState(false)
    const [almacen, setAlmacen] = useState('')
    
    const handleAlmacenChange=(e, {value})=>{
        setAlmacen(value)
    }

    return (
        <>
        <div className='filtros'>
            <h3>Aplicaciones</h3>
            <Modal
                onClose={() => setOpen(false)}
                onOpen={() => setOpen(true)}
                open={open}
                trigger={<button><Icon name='plus' />Aplicar</button>}
                >
                <Modal.Header>Aplicar Producto de :
                <AlmDropdown 
                    placeholder='almacén'
                    value={almacen} 
                    onChange={handleAlmacenChange} 
                    all={1}
                />
                </Modal.Header>
                <Modal.Content>
                    <Aplicar almacen={almacen} onSave={()=>{setOpen(false)}}></Aplicar>
                </Modal.Content>
            </Modal>
        </div>
        <TablaAplicaciones />
        </>
    )
}

class TablaAplicaciones extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            dateFilter:'mes',
            firstDate:'',
            firstDateStr:'',
            secondDate:'',
            secondDateStr:'',
            rows: [],
            sector:"",
            producto:''
        }
        this.unsubscribe=null
    }
    async componentDidMount() {
        this.database = await getCompanyCollection('Aplicaciones')
        this.GetData()
    }
    componentDidUpdate(prevProps, prevState){
        let filtersHaveChanged=false
        if(this.state.sector!==prevState.sector)
            filtersHaveChanged=true
        if(this.state.producto!==prevState.producto)
            filtersHaveChanged=true
        if(this.state.firstDate!== prevState.firstDate && this.state.secondDate!=='')
            filtersHaveChanged=true
        if(this.state.secondDate!==prevState.secondDate && this.firstDate!=='')
            filtersHaveChanged=true
        if(filtersHaveChanged){
            this.unsubscribe()
            this.GetData()
        }
    }
    filterBySector=dbReference=>{
        if(this.state.sector==='' || this.state.sector==='Todas') return dbReference
        return dbReference.where('zona', '==', this.state.sector)   
    }
    filterByProduct=dbReference=>{
        if(this.state.producto==='' || this.state.producto==='Todos') return dbReference
        return dbReference.where('producto', '==', this.state.producto)   
    }
    setReference=()=>{
        let dbReference=this.database
        dbReference=this.filterBySector(dbReference)
        dbReference=this.filterByDate(dbReference)
        dbReference=this.filterByProduct(dbReference)
        return dbReference
    }
    GetData = () => {
        this.unsubscribe=this.setReference().orderBy('fecha', 'desc')
            .onSnapshot(snap => {
                const rows = []
                for (let i = 0; i < snap.docs.length; i++) {
                    rows.push(snap.docs[i].data())
                }
                this.setState({
                    rows: rows
                })
            })
        return null
    }
    handleSectorChange=(e, {value})=>{
        this.setState({sector:value})
    }
    handleProductChange=(e, {value})=>{
        this.setState({producto:value})
    }
    handleSpecificDateChange=(e, {name, value})=>{
        const date=DateUtilities.parseDate(value)
        this.setState({
            [name]:date,
            [name+'Str']:value
        })
    }
    filterByDate=(dbReference)=>{
        if(this.state.dateFilter==='specificDateRange'){
            if(this.state.firstDate!=='' && this.state.secondDate!==''){
                return this.filterSpecificDates(dbReference)
            }
        }
        if(this.state.dateFilter==='mes'){
            return this.filterEsteMes(dbReference)
        }
        return dbReference
    }
    filterEsteMes=dbReference=>{
        let first = DateUtilities.getFirstDayOfMonth()
        return dbReference.where('fecha', '>=', first)
    }
    filterSpecificDates=dbReference=>{
        return dbReference.where('fecha', '>=', this.state.firstDate).where('fecha', '<=', DateUtilities.addDays(this.state.secondDate, 1))
    }
    handleDateFilterChange=(e, {value})=>{
        this.setState({dateFilter:value})
    }
    render() {
        return (
            <section>
                <div className="filtros">
                    <Single 
                        tabla='Zonas' 
                        columna='sector'
                        placeholder='Zonas' 
                        value={this.state.sector}
                        onChange={this.handleSectorChange} 
                        incluir={["Todas"]}
                    />
                    <Single
                        tabla='Productos' 
                        columna='nombre'
                        placeholder='Producto' 
                        value={this.state.producto}
                        onChange={this.handleProductChange} 
                        incluir={["Todos"]}
                    />
                    <div>
                        <Dropdown
                            fluid
                            selection
                            options={[
                                {key:1, text:'Este Mes', value:'mes'},
                                {key:2, text:'Fechas específicas', value:'specificDateRange'},
                            ]}
                            name='dateFilter'
                            value={this.state.dateFilter}
                            onChange={this.handleDateFilterChange}
                        />
                    </div>
                    {
                        this.state.dateFilter==='specificDateRange'
                            ?
                        <>
                        <div>
                            <h3>Del</h3>
                            <Input
                                type='date'
                                value={this.state.firstDateStr}
                                name='firstDate'
                                onChange={this.handleSpecificDateChange}
                            />
                        </div>
                        <div>
                            <h3>Al</h3>
                            <Input
                                type='date'
                                value={this.state.secondDateStr}
                                name='secondDate'
                                onChange={this.handleSpecificDateChange}
                            />
                        </div>
                        </>
                        :null
                    }
                </div>
                
                <div  className="body tabla">
                <table><tbody>
                    <tr>
                        <th>Producto</th>
                        <th>Zona</th>
                        <th>Cantidad</th>
                        <th>Fecha</th>
                    </tr>
                    {this.state.rows.map((row ,i) => {
                        return (
                            <Table.Row key={i} >
                                <Table.Cell>{row.producto}</Table.Cell>
                                <Table.Cell>{row.zona}</Table.Cell>
                                <Table.Cell>{`${row.cantidad} ${row.unidades || ''}`}</Table.Cell>
                                <Table.Cell>{row.fecha.toDate().toLocaleDateString()}</Table.Cell>
                            </Table.Row>
                        )
                    })}
                </tbody></table>
                </div>
            </section>
        )
    }
}

export default Aplicaciones
